module.exports = __webpack_public_path__ + "img/not-authorized-dark.d976d3a1.svg";